/**
 * permissions.ts — единый источник правды для ролей
 *
 * ⚠️  ЧТОБЫ ДОБАВИТЬ НОВУЮ РОЛЬ (например 'moderator'):
 *   1. Измени isTeacherRole() ниже — добавь || role === 'moderator'
 *   2. Измени server-patches/RolesAPI.js на бэкенде
 *   3. Больше нигде ничего менять не нужно
 */
import type { UserRole } from '@/api/types';

/**
 * Пользователь имеет права преподавателя:
 * может создавать группы, видеть учеников, управлять контентом.
 * admin = тоже преподаватель по умолчанию.
 */
export function isTeacherRole(role?: UserRole | string | null): boolean {
  return role === 'teacher' || role === 'admin' || role === 'moderator';
}

/**
 * Пользователь является администратором (только admin).
 * Используется для доступа к /admin панели, управления пользователями, ценами.
 */
export function isAdminRole(role?: UserRole | string | null): boolean {
  return role === 'admin';
}

/**
 * Пользователь является студентом (не имеет прав преподавателя).
 */
export function isStudentRole(role?: UserRole | string | null): boolean {
  return !isTeacherRole(role);
}

/**
 * Название роли для отображения в UI
 */
export function getUserRoleLabel(role?: UserRole | string | null): string {
  switch (role) {
    case 'teacher':
      return 'Преподаватель';
    case 'admin':
      return 'Администратор';
    case 'moderator':
      return 'Модератор';
    case 'student':
      return 'Студент';
    default:
      return 'Студент';
  }
}

